var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-interpreting-subscriber-component" }, [
    _c("div", { staticClass: "room-interpreting-subscriber" }, [
      _c("div", { staticClass: "interpreting subscriber" }, [
        _c("div", { staticClass: "interpreting-header" }, [
          _c("div", { staticClass: "interpreting-title-container" }, [
            _c("p", { staticClass: "interpreting-title" }, [
              _vm._v(_vm._s(_vm.$t("interpret.lang.title"))),
            ]),
          ]),
          _c("button", {
            staticClass: "interpreting-close-button",
            on: { click: _vm.onClose },
          }),
        ]),
        _c("div", { staticClass: "interpreting-body" }, [
          _c("div", { staticClass: "interpreting-audio-control" }, [
            _c("div", { staticClass: "interpreting-audio-control-form" }, [
              _c("p", { staticClass: "interpreting-audio-control-title" }, [
                _vm._v(_vm._s(_vm.$t("interpret.left"))),
              ]),
              _c("input", {
                staticClass: "interpreting-audio-control-input",
                attrs: { type: "range" },
              }),
              _c("p", { staticClass: "interpreting-audio-control-title" }, [
                _vm._v(_vm._s(_vm.$t("interpret.right"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "interpreting-language-list-wrapper" }, [
            _c(
              "ul",
              { staticClass: "interpreting-language-list" },
              _vm._l(_vm.languageList, function (language, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    staticClass: "interpreting-language-item",
                    class: { selected: _vm.subscribeLanguage === language },
                  },
                  [
                    _c("p", { staticClass: "interpreting-language-title" }, [
                      _vm._v(_vm._s(language)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "interpreting-language-button-container" },
                      [
                        _c(
                          "div",
                          { staticClass: "interpreting-set-interpreter" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "interpreting-set-interpreter-button subscribeInterpretingBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.onSubscribe(language)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("interpret.subscribe.title"))
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "interpreting-footer" }, [
          _c(
            "button",
            {
              staticClass: "interpreting-change-mode-button disable",
              on: { click: _vm.onUnsubscribe },
            },
            [_vm._v(_vm._s(_vm.$t("interpret.subscribe.cancel")))]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }